// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d709620d","453":"8416de6a","644":"0a2601ea","732":"ed82455e"}[chunkId] + ".chunk.js";
};